export const mensagemVazio = {
    variant: "",
    message: "",
};

export const showMessage = ({ variant, message }, setMessage) => {
    setMessage({ variant, message });

    setTimeout(() => {
        setMessage(mensagemVazio);
    }, 10000);
};

export const verticaisMercadoLivre = [
    "Calçados, Roupas e Bolsas",
    "Casa, Móveis e Decoração",
    "Esportes e Fitness",
    "Beleza e Cuidado Pessoal",
    "Celulares e Telefones",
    "Eletrodomésticos",
    "Eletrônicos, Áudio e Vídeo",
    "Ferramentas",
    "Informática",
    "Brinquedos e Hobbies",
    "Outros",
];

export const IcampanhasItensStatus = {
    WAITING: "WAITING_FOR_APPROVAL",
    REPROVED: "REPROVED",

    APPROVED: "APPROVED",

    WAITING_CLIENT: "WAITING_FOR_CLIENTE_APPROVAL",
    REPROVED_CLIENT: "REPROVED_CLIENT",

    APPROVED_CLIENT: "APPROVED_CLIENT",

    COMPLETED: "COMPLETED",

    CANCELED: "CANCELED",
};

export const EXCLUSIVO_OPTIONS = [
    { value: "EXCLUSIVO", title: "Exclusivo" },
    { value: "EXCLUSIVO_E_ABERTO", title: "Exclusivo e Aberto" },
    { value: "SO_ABERTO", title: "Só Aberto" },
];

export const POST_STATUS = [
    { value: "PENDENTE", label: "Pendente" },
    { value: "APROVADO", label: "Aprovado" },
    { value: "REPROVADO", label: "Reprovado" },
];

export const PRODUCTION_ENVIRONMENTS = [
    "default",
    "favela",
    "wizard",
];
